import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Button } from 'antd';
import ProdLogo from '@/assets/icons/prod-logo.svg';
import { ReactComponent as FileIcon } from '@/assets/icons/file.svg';
import { ReactComponent as Close } from '@/assets/icons/close_line.svg';
import sentGAEvent from '@/ga';
import AudioExtractorWork from './children/AudioExtractorWork';
import Beyond2G from './advertise/Beyond2G.jsx';
import ModalAdvertise from './modalAdvertise';
import actions from '@/redux/action';
import Cookies from 'js-cookie';
import '@/assets/audioExtractor.less';
import Utils from '../../utils';
import indexDB from '../../utils/indexDB';
class AudioExtractor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workPlaceVisible: false,
    };
  }

  componentDidMount() {
    if (Cookies.get('ignoreBoardAdvertise') == undefined) {
      let res = +Cookies.get('advertiseType');
      sentGAEvent({
        category: 'vc_referral',
        action:
          res == 2
            ? 'AudioExtractor_FloatingFasterShow'
            : res == 3
            ? 'AudioExtractor_FloatingFormatsShow'
            : 'AudioExtractor_FloatingSizeShow',
      });
    }
    this.getDBFile();
  }

  getDBFile = async () => {
    let res = await indexDB.read();
    console.log('拿到的文件', res);
    if (res?.file) {
      this.props.onAudioExtractorFileChange(res.file);
      this.setState({ workPlaceVisible: true });
    }
  };

  openDialog = () => {
    sentGAEvent({
      category: 'vc_referral',
      action: 'AudioExtractor_UnderChooseFileClick',
    });
    this.props.advertiseConfig({
      isShowBtn: false,
      isShowHeader: false,
      headerObj: '',
      titleIndex: 2,
      imgIndex: 3,
      source: 'fontUrl',
    });
    this.props.openAdvertiseDialog(true);

    sentGAEvent({
      category: 'vc_referral',
      action: 'AudioExtractor_UnderChooseFileShow',
    });
  };

  closeAdvertise = () => {
    let advertiseDom = document.getElementById('advertiseBoard');
    advertiseDom.style.display = 'none';
    let res = +Cookies.get('advertiseType');
    sentGAEvent({
      category: 'vc_referral',
      action:
        res == 3
          ? 'AudioExtractor_FloatingFasterClose'
          : res == 1
          ? 'AudioExtractor_FloatingFormatsClose'
          : 'AudioExtractor_FloatingSizeClose',
    });
  };

  downloadDesktop = () => {
    Cookies.set('ignoreBoardAdvertise', 'ignoreBoardAdvertise', {
      expires: 30,
    });
    window.location.href = Utils.getHitPawConvertLink();
    this.closeAdvertise();
  };

  getRandomIntInclusive = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min; //含最大值，含最小值
  };
  render() {
    const { t } = this.props;
    console.log(this.props.advertiseConfigData);
    return (
      <div className='AudioExtractor'>
        <div className='audio-work-hd'>
          {Utils.getSystemType() != 'other' ? (
            Cookies.get('ignoreBoardAdvertise') == undefined ? (
              <div id='advertiseBoard' className='advertiseBoard'>
                <Beyond2G downloadDesktop={this.downloadDesktop} />
                <Close
                  style={{ cursor: 'pointer' }}
                  onClick={() => this.closeAdvertise()}
                />
              </div>
            ) : (
              ''
            )
          ) : (
            ''
          )}

          <h1 className='container'>{t('HitPaw Online Audio Extractor')}</h1>
          <p className='container'>
            {t('Extract sound from videos with ease.')}
          </p>
          {!this.state.workPlaceVisible ? (
            <Button
              size='large'
              icon={<FileIcon />}
              onClick={() => this.setState({ workPlaceVisible: true })}
            >
              {t('upload:Choose File')}
            </Button>
          ) : null}
          {/* {Utils.getSystemType() != 'other' && !this.props.isHide ? (
            <p onClick={() => this.openDialog()} className='downloadDesktop'>
              <img src={ProdLogo} />
              {t('advertise:DownloadDesktopToExtract')}
            </p>
          ) : null} */}
        </div>
        <ModalAdvertise />
        {this.state.workPlaceVisible ? <AudioExtractorWork /> : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  visible: state.common.advertiseDialog,
  file: state.files,
  advertiseConfigData: state.common.advertiseConfig,
  isHide: state.common.isHide,
});
const mapDispatchToProps = (dispatch) => ({
  advertiseConfig: (advertiseConfig) =>
    dispatch(actions.advertiseConfig(advertiseConfig)),
  openAdvertiseDialog: (visible) =>
    dispatch(actions.openAdvertiseDialog(visible)),
  onAudioExtractorFileChange: (audioExtractorFile) =>
    dispatch(actions.onAudioExtractorFileChange(audioExtractorFile)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(['audioExtractor', 'upload'])(AudioExtractor));
